import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment_ from 'moment';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
const moment = moment_;

export interface checkinListDialogData {
  edata: any;
  page: any;
  columns:any;
}

@Component({
    selector: 'app-add-scheduler-reports',
    templateUrl: './add-scheduler-reports.component.html',
    styleUrls: ['./add-scheduler-reports.component.scss'],
    standalone: false
})
export class AddSchedulerReportsComponent implements OnInit {

  FormValid: UntypedFormGroup;
  endDateTemp: any = moment(null)
  today = new Date()
  startDatetemp: any = moment(null)
  backgroundColorButton = "";
  scheduleTimeData:any;
  reportNameData:any;
  validation_messages:any;
  updateSchedulerReport:any;
  reportTypeData = [{"reporttypeid":1,"reporttypename":"Report Type 1"},{"reporttypeid":2,"reporttypename":"Report Type 2"},
  {"reporttypeid":3,"reporttypename":"Report Type 3"},{"reporttypeid":4,"reporttypename":"Report Type 4"}]

  reportReferenceData = [{"reportreferenceid":1,"reportreferencename":"Report Reference 1"},{"reportreferenceid":2,"reportreferencename":"Report Reference 2"},
  {"reportreferenceid":3,"reportreferencename":"Report Reference 3"},{"reportreferenceid":4,"reportreferencename":"Report Reference 4"}]

  productsData = [{"productid":1,"productname":"Product 1"},{"productid":2,"productname":"Product 2"},
  {"productid":3,"productname":"Product 3"},{"productid":4,"productname":"Product 4"}]

  authoritiesData = [{"authoritiesid":1,"authoritiesname":"Authorities 1"},{"authoritiesid":2,"authoritiesname":"Authorities 2"},
  {"authoritiesid":3,"authoritiesname":"Authorities 3"},{"authoritiesid":4,"authoritiesname":"Authorities 4"}]

  schedulerReportsData= {
    "reportname":"",
    "reporttypeid":"",
    "reportreferenceid":"",
    "productid":"",
    "authoritiesid":"",
    "reporttypename":"",
    "reportreferencename":"",
    "productname":"",
    "authoritiesname":"",
    "date":"",
    "scheduletime":"",
    "runstate":"",
    "startdate":"",
    "enddate":""
  }

  constructor( private localStorageSettings: LocalStorageSettingsService,
    public dialogref: MatDialogRef<AddSchedulerReportsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData,
    private errorMsg: ErrorMessages,
    private validation: validationmethod
    ) {
      this.validation_messages = this.errorMsg.schedulerReportMessages;
     }

  ngOnInit() {
    this.formvalidations();
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    this.schedulerReportsData.runstate="start"
    this.updateSchedulerReport = this.data.edata
    if(this.updateSchedulerReport != null){
      this.reportNameData=this.updateSchedulerReport.reportname;
      this.scheduleTimeData=moment(this.updateSchedulerReport.scheduleTimeData).format('HH:mm');
      this.schedulerReportsData.reporttypeid=this.updateSchedulerReport.reporttypeid;
      this.schedulerReportsData.reportreferenceid=this.updateSchedulerReport.reportreferenceid;
      this.schedulerReportsData.productid=this.updateSchedulerReport.productid;
      this.schedulerReportsData.authoritiesid=this.updateSchedulerReport.authoritiesid;
      this.schedulerReportsData.date=this.updateSchedulerReport.date;
      this.schedulerReportsData.runstate=this.updateSchedulerReport.runstate;
      this.startDatetemp=this.updateSchedulerReport.startdate;
      this.endDateTemp=this.updateSchedulerReport.enddate;
    }

    
  }

  formvalidations() {
    this.FormValid = new UntypedFormGroup({
      reportname: new UntypedFormControl('', [Validators.required,this.validation.noWhitespaceValidator,Validators.maxLength(150)]),
      reporttypeid: new UntypedFormControl('', [Validators.required]),
      reportreferenceid: new UntypedFormControl('', [Validators.required]),
      productid: new UntypedFormControl('', [Validators.required]),
      authoritiesid: new UntypedFormControl('', [Validators.required]),
      date: new UntypedFormControl(''),
      startDate: new UntypedFormControl('', [Validators.required]),
      endDate: new UntypedFormControl('', [Validators.required]),
      scheduletime: new UntypedFormControl('', [Validators.required])
    })
  }

  selectReportType(e){
    console.log(e);
    this.schedulerReportsData.reporttypeid=e;
    if(this.schedulerReportsData.reporttypeid != null){
      for(let i=0;i<this.reportTypeData.length;i++){
        if(this.reportTypeData[i].reporttypeid==e){
        this.schedulerReportsData.reporttypename=this.reportTypeData[i].reporttypename;
        console.log(this.schedulerReportsData.reporttypename)
        }
      }
    }
  }

  selectReportReference(e){
    console.log(e);
    this.schedulerReportsData.reportreferenceid=e;
    if(this.schedulerReportsData.reportreferenceid != null){
      for(let i=0;i<this.reportReferenceData.length;i++){
        if(this.reportReferenceData[i].reportreferenceid==e){
        this.schedulerReportsData.reportreferencename=this.reportReferenceData[i].reportreferencename;
        console.log(this.schedulerReportsData.reportreferencename)
        }
      }
    }
  }

  selectProducts(e){
    console.log(e);
    this.schedulerReportsData.productid=e;
    if(this.schedulerReportsData.productid != null){
      for(let i=0;i<this.productsData.length;i++){
        if(this.productsData[i].productid==e){
        this.schedulerReportsData.productname=this.productsData[i].productname;
        console.log(this.schedulerReportsData.productname)
        }
      }
    }
  }

  selectAuthorities(e){
    console.log(e);
    this.schedulerReportsData.authoritiesid=e;
    if(this.schedulerReportsData.authoritiesid != null){
      for(let i=0;i<this.authoritiesData.length;i++){
        if(this.authoritiesData[i].authoritiesid==e){
        this.schedulerReportsData.authoritiesname=this.authoritiesData[i].authoritiesname;
        console.log(this.schedulerReportsData.authoritiesname)
        }
      }
    }
  }

  ChangeSelect(event) {
    var getyear = moment().format("YYYY");
    var getmonth = moment().format("MM");
    if (event.value == "today") {
      this.endDateTemp = moment()
      this.startDatetemp = moment()
    } else if (event.value == "currentWeek") {
      this.endDateTemp = moment().endOf('week')
      this.startDatetemp = moment().startOf("isoWeek");
    } else if (event.value == "currentMonth") {
      this.endDateTemp = moment().endOf('month')
      this.startDatetemp = moment(getyear + "-" + getmonth, "YYYY-M").startOf("month");
    }  else if (event.value == "currentHalfYear") {
       this.endDateTemp = moment().endOf('quarter')
       this.startDatetemp = moment().startOf("year");
     } else if (event.value == "currentYear") {
      this.endDateTemp = moment().endOf('year')
      this.startDatetemp = moment().startOf("year");
    }
  }

  SaveData(){
    console.log("Save Data");
    if (!this.FormValid.valid) {
      this.validation.validateAllFormFields(this.FormValid);
      this.validation.getvalidationmessage();
      return
    } else {
        this.schedulerReportsData.scheduletime=this.scheduleTimeData;
        this.schedulerReportsData.reportname=this.reportNameData;
        this.schedulerReportsData.startdate = moment(this.startDatetemp).format('YYYY-MM-DD');
        this.schedulerReportsData.enddate = moment(this.endDateTemp).format('YYYY-MM-DD');
        console.log(this.schedulerReportsData);
        this.dialogref.close(this.schedulerReportsData);
    }
  }

  CancelData(){
    console.log("Cancel Data");
    this.dialogref.close();
    this.reset();
    this.schedulerReportsData.reportname="";
    this.schedulerReportsData.reporttypeid="";
    this.schedulerReportsData.reportreferenceid="";
    this.schedulerReportsData.productid="";
    this.schedulerReportsData.authoritiesid="";
    this.schedulerReportsData.scheduletime="";
    this.schedulerReportsData.startdate="";
    this.schedulerReportsData.enddate="";
    this.schedulerReportsData.date="";
    this.scheduleTimeData=null;
    this.reportNameData=null;
    this.endDateTemp = moment(null);
    this.startDatetemp = moment(null);

  }

  reset(){
    this.FormValid.controls['reportname'].reset();
    this.FormValid.controls['reporttypeid'].reset();
    this.FormValid.controls['reportreferenceid'].reset();
    this.FormValid.controls['productid'].reset();
    this.FormValid.controls['authoritiesid'].reset();
    this.FormValid.controls['startdate'].reset();
    this.FormValid.controls['enddate'].reset();
    this.FormValid.controls['scheduletime'].reset();
  }

  radioChange(e){
    console.log(e.value);
    this.schedulerReportsData.runstate=e.value;
  }

}
